import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';

const useStyles = makeStyles(() => ({
  chip: {
    position: 'absolute',
    top: 0,
    right: 0,
    fontWeight: 600,
    fontStyle: 'italic',
    backgroundColor: 'transparent',
  },
}));

const CostTypeChip = ({ label, className }) => {
  const classes = useStyles();

  return <Chip size="small" label={label} className={cn(classes.chip, className)} />;
};

CostTypeChip.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};

CostTypeChip.defaultProps = {
  className: '',
};

export default CostTypeChip;
